<script lang="ts" setup>
defineProps({
  // eslint-disable-next-line vue/require-default-prop
  error: Object,
})
</script>

<template>
  <div class="flex min-h-[100vh] flex-col justify-between">
    <LayoutHeader />
    <div class="grid flex-grow items-center">
      <LayoutContainer>
        <div class="grid items-center justify-center gap-4 py-8 text-center">
          <div>
            <div class="text-8xl font-bold">ERROR</div>
            <div class="text-xl">{{ error?.message }}</div>
          </div>
          <div
            v-if="error?.stack"
            class="overflow-x-scroll text-left text-xs"
          >
            <div v-dompurify-html="error?.stack" />
          </div>
        </div>
      </LayoutContainer>
    </div>
    <LayoutFooter />
  </div>
</template>
